<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CCard>
          <CCardHeader>
            <div class="form-group">
              <label>Danh sách sim</label>
            </div>
          </CCardHeader>
          <CCardBody>
            <div v-if="!isDone" class="mb-3">
              <div class="form-group">
                <label>Quét barcode</label>
                <div class="form-inline">
                  <input
                    ref="barcodeInput"
                    class="form-control mr-2"
                    style="min-width: 320px"
                    v-model="barcode"
                    autocomplete="off"
                    placeholder="Bắn IMEI hoặc ICCID"
                    @keyup="onScanKey"
                  />
                  <CButton color="success" class="btn-action-primary" :disabled="scanning" @click="scan">
                    Nhận mã
                  </CButton>
                </div>
                <small class="text-muted">{{ scanHint }}</small>
              </div>
              <div class="form-inline mt-2">
                <input
                  class="form-control mr-2"
                  style="min-width: 280px"
                  v-model="keyword"
                  placeholder="IMEI / SĐT / ICCID"
                  @keyup.enter="search"
                />
                <CButton color="primary" class="btn-action-primary" :disabled="searching" @click="search">
                  Tìm sim
                </CButton>
              </div>
              <small class="text-muted">{{ hint }}</small>
              <div v-if="searched && results.length === 0" class="mt-2" style="color:#969696;">Không có sim phù hợp</div>
              <table v-if="results.length" class="table table-sm mt-2 mb-0">
                <tbody>
                  <tr v-for="item in results" :key="'search-' + item.simId">
                    <td>{{ item.carrier }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.iccid }}</td>
                    <td>{{ item.source }}</td>
                    <td>{{ item.lotName }}</td>
                    <td class="text-right">
                      <div class="action-btn-wrapper justify-content-end">
                        <CButton color="success" variant="outline" square size="sm" v-c-tooltip.hover="'Chọn'" @click="add(item)">
                          <i class="fa fa-plus"></i>
                        </CButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive">
              <div class="mb-2 d-flex align-items-center">
                <strong class="mr-3">Sim trên phiếu ({{ sims.length }})</strong>
                <template v-if="inventoryType === 'out' && !isDone">
                  <CButton color="primary" size="sm" class="mr-2" :disabled="selectedBlank.length === 0" @click="openBulk('activate')">
                    Kích hoạt đã chọn ({{ selectedBlank.length }})
                  </CButton>
                  <CButton color="info" size="sm" class="mr-2" :disabled="selectedActive.length === 0" @click="openBulk('extend')">
                    Gia hạn đã chọn ({{ selectedActive.length }})
                  </CButton>
                  <CButton color="warning" size="sm" class="mr-2" :disabled="selectedActive.length === 0" @click="openBulk('correct')">
                    Sửa đã chọn ({{ selectedActive.length }})
                  </CButton>
                  <CButton color="danger" size="sm" :disabled="selectedActive.length === 0" @click="openBulk('cancel')">
                    Hủy kích hoạt ({{ selectedActive.length }})
                  </CButton>
                </template>
              </div>
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th v-if="canPackage" style="width: 40px" class="text-center">
                      <input type="checkbox" :checked="allSelected" @change="toggleAll" />
                    </th>
                    <th style="width: 50px">#</th>
                    <th>Nhà mạng</th>
                    <th>IMEI</th>
                    <th>SĐT</th>
                    <th>ICCID</th>
                    <th>Nhập từ</th>
                    <th>Lô</th>
                    <th>Ngày bắt đầu</th>
                    <th>Ngày hết hạn</th>
                    <th>Ngày kích hoạt</th>
                    <th>Ngày gia hạn</th>
                    <th v-if="!isDone" style="width: 160px">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-if="sims.length === 0">
                    <td :colspan="emptyColspan" class="text-center" style="color:#969696;">Chưa có sim trên phiếu</td>
                  </tr>
                  <tr v-for="(item, index) in sims" :key="'sim-' + (item.simId || index)">
                    <td v-if="canPackage" class="text-center">
                      <input type="checkbox" :checked="isSelected(item)" @change="toggleSelected(item)" />
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.carrier }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.iccid }}</td>
                    <td>{{ item.source }}</td>
                    <td>{{ item.lotName }}</td>
                    <td class="text-nowrap">{{ item.startDate ? $helper.formatDateDDMMYYYY(item.startDate) : "Chưa kích hoạt" }}</td>
                    <td class="text-nowrap">{{ $helper.formatDateDDMMYYYY(item.expireDate) }}</td>
                    <td class="text-nowrap">{{ $helper.formatDateDDMMYYYY(item.activatedDate) }}</td>
                    <td class="text-nowrap">{{ $helper.formatDateDDMMYYYY(item.extendDate) }}</td>
                    <td v-if="!isDone" class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <template v-if="canPackage">
                          <CButton v-if="!item.startDate && !item.expireDate" color="primary" variant="outline" square size="sm"
                            v-c-tooltip.hover="'Kích hoạt'" @click="$refs.packageForm.open(item, 'activate')">
                            <i class="fa fa-check"></i>
                          </CButton>
                          <template v-else-if="item.startDate && item.expireDate">
                            <CButton color="info" variant="outline" square size="sm" v-c-tooltip.hover="'Gia hạn'"
                              @click="$refs.packageForm.open(item, 'extend')">
                              <i class="fa fa-calendar-plus-o"></i>
                            </CButton>
                            <CButton color="warning" variant="outline" square size="sm" v-c-tooltip.hover="'Sửa kích hoạt'"
                              @click="$refs.packageForm.open(item, 'correct')">
                              <i class="fa fa-pencil"></i>
                            </CButton>
                            <CButton color="danger" variant="outline" square size="sm" v-c-tooltip.hover="'Hủy kích hoạt'"
                              @click="$refs.packageForm.open(item, 'cancel')">
                              <i class="fa fa-undo"></i>
                            </CButton>
                          </template>
                        </template>
                        <CButton color="danger" variant="outline" square size="sm" v-c-tooltip.hover="'Xóa'" @click="remove(item)">
                          <i class="fa fa-trash"></i>
                        </CButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <SimPackageForm ref="packageForm" @saved="onPackageSaved"></SimPackageForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SimPackageForm from "../sim/PackageForm";

export default {
  name: "StockSimLines",
  components: { SimPackageForm },
  props: {
    isDone: { type: Boolean, default: false },
    inventoryType: { type: String, default: "" },
    stockId: { default: null },
  },
  notifications: {
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
  },
  data: function () {
    return {
      keyword: "",
      barcode: "",
      searching: false,
      scanning: false,
      searched: false,
      ready: !this.stockId,
      sims: [],
      results: [],
      selectedIds: [],
    };
  },
  computed: {
    hint: function () {
      if (this.inventoryType === "out") {
        return "Chỉ chọn sim đang trong kho và chưa nằm trên phiếu nháp khác.";
      }
      return "Chỉ chọn sim chưa trong kho và chưa nằm trên phiếu nháp khác.";
    },
    scanHint: function () {
      if (this.inventoryType === "out") {
        return "Đưa con trỏ vào ô rồi bắn mã. Có thể xuất khi chưa kích hoạt. Chọn nhiều sim để kích hoạt cùng ngày hoặc gia hạn cùng lúc.";
      }
      return "Đưa con trỏ vào ô rồi bắn mã IMEI hoặc ICCID của sim chưa trong kho.";
    },
    emptyColspan: function () {
      let count = 11;
      if (!this.isDone) {
        count += 1;
      }
      if (this.canPackage) {
        count += 1;
      }
      return count;
    },
    canPackage: function () {
      return this.inventoryType === "out" && !this.isDone;
    },
    selectedBlank: function () {
      return this.selectedSims().filter(function (item) {
        return !item.startDate && !item.expireDate;
      });
    },
    selectedActive: function () {
      return this.selectedSims().filter(function (item) {
        return item.startDate && item.expireDate;
      });
    },
    allSelected: function () {
      return this.sims.length > 0 && this.selectedIds.length === this.sims.length;
    },
  },
  methods: {
    isReady: function () {
      return this.ready;
    },
    getIds: function () {
      return this.sims.map(function (item) {
        return item.simId;
      });
    },
    clear: function () {
      this.sims = [];
      this.results = [];
      this.searched = false;
      this.selectedIds = [];
    },
    sameId: function (left, right) {
      return String(left) === String(right);
    },
    add: function (item) {
      let exists = this.sims.some((row) => this.sameId(row.simId, item.simId));
      if (exists) {
        return;
      }
      this.sims = this.sims.concat([item]);
      this.results = this.results.filter((row) => !this.sameId(row.simId, item.simId));
    },
    remove: function (item) {
      this.sims = this.sims.filter((row) => !this.sameId(row.simId, item.simId));
      this.selectedIds = this.selectedIds.filter((id) => !this.sameId(id, item.simId));
    },
    selectedSims: function () {
      let that = this;
      return this.sims.filter(function (item) {
        return that.selectedIds.some(function (id) {
          return that.sameId(id, item.simId);
        });
      });
    },
    isSelected: function (item) {
      return this.selectedIds.some((id) => this.sameId(id, item.simId));
    },
    toggleSelected: function (item) {
      if (this.isSelected(item)) {
        this.selectedIds = this.selectedIds.filter((id) => !this.sameId(id, item.simId));
      } else {
        this.selectedIds = this.selectedIds.concat([item.simId]);
      }
    },
    toggleAll: function () {
      if (this.allSelected) {
        this.selectedIds = [];
      } else {
        this.selectedIds = this.sims.map(function (item) {
          return item.simId;
        });
      }
    },
    openBulk: function (mode) {
      const rows = mode === "activate" ? this.selectedBlank : this.selectedActive;
      if (!rows.length) {
        this.showErrorMsg({
          message: mode === "extend" ? "Chọn sim đã kích hoạt để gia hạn" : mode === "activate" ? "Chọn sim chưa kích hoạt" : "Chọn sim đã kích hoạt"
        });
        return;
      }
      this.$refs.packageForm.openList(rows, mode);
    },
    onPackageSaved: function (result) {
      const rows = Array.isArray(result) ? result : [result];
      const saved = {};
      rows.forEach(function (row) {
        if (row && row.id !== undefined && row.id !== null) {
          saved[String(row.id)] = row;
        }
      });
      this.sims = this.sims.map((row) => {
        const found = saved[String(row.simId)];
        if (!found) {
          return row;
        }
        return Object.assign({}, row, {
          startDate: found.startDate || null,
          expireDate: found.expireDate || null,
          activatedDate: found.activatedDate || null,
          extendDate: found.extendDate || null
        });
      });
      this.selectedIds = [];
    },
    focusBarcode: function () {
      let input = this.$refs.barcodeInput;
      if (input) {
        input.focus();
      }
    },
    onScanKey: function (event) {
      if (event.key !== "Enter" && event.key !== "Tab") {
        return;
      }
      if (!(this.barcode || "").trim()) {
        return;
      }
      event.preventDefault();
      this.scan();
    },
    scan: function () {
      let that = this;
      let input = this.$refs.barcodeInput;
      let code = ((input && input.value) || this.barcode || "").trim();
      if (!code || this.scanning) {
        return;
      }
      if (!this.inventoryType) {
        this.showErrorMsg({ message: "Chọn loại phiếu trước khi quét" });
        return;
      }
      this.scanning = true;
      this.$helper.loadDataSource({
        url: "/stock-sim/scan",
        dataSubmit: function () {
          return {
            keyword: code,
            inventoryType: that.inventoryType,
            stockId: that.stockId || null,
          };
        },
        successCallback: function (response) {
          that.scanning = false;
          that.barcode = "";
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$nextTick(function () {
              that.focusBarcode();
            });
            return;
          }
          let item = response.data.data;
          if (that.sims.some((row) => that.sameId(row.simId, item.simId))) {
            that.showErrorMsg({ message: "Sim đã có trên phiếu" });
          } else {
            that.add(item);
            that.showSuccessMsg({ message: "Đã thêm sim " + (item.imei || item.iccid || "") });
          }
          that.$nextTick(function () {
            that.focusBarcode();
          });
        },
        errorCallback: function (error) {
          that.scanning = false;
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    search: function () {
      let that = this;
      if (!this.inventoryType) {
        this.showErrorMsg({ message: "Chọn loại phiếu trước khi tìm sim" });
        return;
      }
      this.searching = true;
      this.$helper.loadDataSource({
        url: "/stock-sim/search",
        dataSubmit: function () {
          return {
            keyword: that.keyword,
            inventoryType: that.inventoryType,
            stockId: that.stockId || null,
          };
        },
        successCallback: function (response) {
          that.searching = false;
          that.searched = true;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            return;
          }
          let rows = response.data.data || [];
          that.results = rows.filter(function (item) {
            return !that.sims.some((row) => that.sameId(row.simId, item.simId));
          });
        },
        errorCallback: function (error) {
          that.searching = false;
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    load: function (stockId) {
      let that = this;
      if (!stockId) {
        this.sims = [];
        this.ready = true;
        this.$emit("loaded");
        return;
      }
      this.ready = false;
      this.$helper.loadDataSource({
        url: "/stock-sim/findByStockId",
        isJsonContentType: false,
        dataSubmit: function () {
          return { stockId: stockId };
        },
        successCallback: function (response) {
          if (response.data && response.data.returnCode === 1) {
            that.sims = response.data.data || [];
            that.ready = true;
            that.$emit("loaded");
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
};
</script>
